// extracted by mini-css-extract-plugin
module.exports = {"h4Class":"H4_h4Class__1S0aA"};